export default {
  nav_spreadsheet: "Feuille de calcul",
  nav_categories: "Catégories",
  nav_guides: "Guides",
  nav_reviews: "Avis",
  nav_shipping: "Expédition",
  nav_safety: "Sécurité",
  nav_language: "Langue",

  hero_eyebrow: "LE CENTRE DE RESSOURCES ALLCHINABUY SPREADSHEET",
  hero_title: "AllChinaBuy Spreadsheet — Trouvez des Produits, Liens & Guides d'Achat",
  hero_subtitle: "Découvrez des ressources organisées AllChinaBuy spreadsheet, des liens produits, des guides d'achat, des conseils QC, des informations d'expédition et des outils utiles — tout en un seul endroit.",
  hero_cta_primary: "Explorer AllChinaBuy Spreadsheet",
  hero_cta_secondary: "Parcourir les Catégories Populaires",
  hero_trust: "Ressource indépendante • Mise à jour régulièrement • Axée sur la sécurité",

  categories_title: "Acheter par Catégorie",
  categories_description: "Parcourez nos catégories sélectionnées et trouvez exactement ce dont vous avez besoin",
  categories_button: "Toutes les Catégories",

  cta_spreadsheet: "AllChinaBuy Spreadsheet",
  cta_buy_now: "Acheter Maintenant",
  cta_explore: "Explorer les Produits",

  value_title: "Tout Ce Dont Vous Avez Besoin pour Naviguer AllChinaBuy",
  value_spreadsheet: "Ressources Spreadsheet",
  value_spreadsheet_desc: "Trouvez des ressources spreadsheet organisées et des références produits.",
  value_discovery: "Découverte de Produits",
  value_discovery_desc: "Explorez les catégories populaires et découvrez des informations produits utiles.",
  value_qc: "Guides QC",
  value_qc_desc: "Apprenez à évaluer les photos de contrôle qualité et les détails produits.",
  value_shipping: "Guides d'Expédition",
  value_shipping_desc: "Comprendre les options d'expédition, les coûts, le suivi et les considérations importantes.",
  value_safety: "Centre de Sécurité",
  value_safety_desc: "Apprenez à réduire les risques courants liés à l'achat, au paiement et aux vendeurs.",
  value_comparison: "Guides de Comparaison",
  value_comparison_desc: "Comparez les plateformes d'achat, les fonctionnalités et les considérations utilisateur.",

  popular_title: "Catégories Populaires AllChinaBuy Spreadsheet",
  popular_desc: "Explorez nos catégories de produits les plus visitées et découvrez les articles tendance",

  how_title: "Comment Utiliser un AllChinaBuy Spreadsheet",
  how_step1_title: "Choisissez une Catégorie",
  how_step1_desc: "Parcourez les produits par catégorie et intention.",
  how_step2_title: "Consultez les Informations Produit",
  how_step2_desc: "Vérifiez les informations disponibles, les références et les considérations QC.",
  how_step3_title: "Comparez les Options",
  how_step3_desc: "Utilisez des tableaux de comparaison et des guides avant de prendre des décisions.",
  how_step4_title: "Continuez vers le Site Principal",
  how_step4_desc: "Utilisez le CTA pertinent lorsque vous êtes prêt à continuer.",

  trust_title: "Conçu pour une Recherche d'Achat Plus Intelligente",
  trust_desc: "AllChinaBuySpreadsheet.fit est une ressource informationnelle indépendante conçue pour organiser des ressources spreadsheet utiles et des informations d'achat. Nous mettons l'accent sur la clarté, les conseils pratiques, la sécurité et le contenu régulièrement mis à jour.",
  trust_point1: "Ressource indépendante",
  trust_point2: "Information transparente",
  trust_point3: "Guides axés sur la sécurité",
  trust_point4: "Mises à jour régulières",
  trust_point5: "Normes éditoriales claires",

  articles_title: "Derniers Guides AllChinaBuy Spreadsheet",
  articles_desc: "Lisez nos articles approfondis pour devenir un acheteur plus intelligent",
  articles_read_more: "Lire la Suite",
  articles_category: "Catégorie",
  articles_read_time: "Temps de lecture",

  final_cta_title: "Prêt à Explorer l'AllChinaBuy Spreadsheet ?",
  final_cta_desc: "Parcourez les dernières ressources, découvrez des catégories utiles et apprenez à naviguer le processus d'achat avec plus de confiance.",
  final_cta_primary: "Explorer AllChinaBuy Spreadsheet",
  final_cta_secondary: "Lire le Guide du Débutant",

  footer_tagline: "Votre ressource indépendante pour les ressources AllChinaBuy spreadsheet et les guides d'achat.",
  footer_resources: "Ressources",
  footer_spreadsheet: "Hub Spreadsheet",
  footer_categories: "Catégories",
  footer_guides: "Guides",
  footer_reviews: "Avis",
  footer_legal: "Légal",
  footer_about: "À Propos",
  footer_privacy: "Politique de Confidentialité",
  footer_terms: "Conditions d'Utilisation",
  footer_disclaimer: "Avertissement",
  footer_contact: "Contact",
  footer_email: "Nous Contacter",
  footer_social: "Suivez-Nous",
  footer_copyright: "AllChinaBuySpreadsheet.fit. Tous droits réservés.",
  footer_independent: "Ceci est un centre de ressources indépendant. Nous ne sommes pas affiliés à AllChinaBuy.",

  article_back: "Retour à l'Accueil",
  article_updated: "Dernière Mise à Jour",
  article_share: "Partager cet article",
  article_related: "Articles Connexes",
  article_read_more: "Lire la Suite",
  article_author: "Équipe Éditoriale",
  article_table_of_contents: "Table des Matières",
  article_jump_to: "Aller à la section",

  safety_title: "Achetez Plus Intelligemment Avec Nos Guides de Sécurité",
  safety_desc: "Avant d'utiliser tout lien produit ou de passer une commande, apprenez à évaluer les vendeurs, les informations produit, les photos QC, les méthodes de paiement et les risques d'expédition.",
  safety_cta: "Visiter le Centre de Sécurité",
  safety_notice: "Vérifiez toujours les informations produit, vendeur, paiement et expédition actuelles avant de commander. Les détails peuvent changer avec le temps.",

  comparison_title: "AllChinaBuy & Plateformes d'Achat Populaires",
  comparison_note: "Vérifiez les informations actuelles avant de commander.",
  comparison_platform: "Plateforme",
  comparison_spreadsheet: "Ressources Spreadsheet",
  comparison_qc: "QC",
  comparison_shipping_info: "Informations d'Expédition",
  comparison_beginner: "Débutant Friendly",

  read_guide: "Lire le Guide",
  learn_more: "En Savoir Plus",
  search_placeholder: "Rechercher des spreadsheets, produits, catégories ou guides AllChinaBuy...",
  search_title: "Trouvez Ce Que Vous Cherchez",
  search_suggested: "Recherches suggérées",
  featured_spreadsheet: "AllChinaBuy Spreadsheet",
  featured_spreadsheet_desc: "Commencez par la ressource la plus importante de ce site. Explorez des informations spreadsheet organisées, des catégories, des références produits et des conseils d'achat pratiques.",
  explore_spreadsheet: "Explorer le Spreadsheet",
  home_breadcrumb: "Accueil",
  article_breadcrumb: "Articles",
  scroll_to_top: "Retour en haut",
  main_website: "Site Principal",
  visit_main: "Visiter le Site Principal",

  // Products
  products_title: "Tous les Produits du Kakobuy Spreadsheet",
  products_subtitle: "Parcourez notre collection complète de produits sélectionnés avec des liens directs pour acheter",
  products_view_all: "Voir tous les {category}",
  products_buy_now: "Acheter",
  products_from: "À partir de",
};